
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PassionTracker, RoadmapBuilder, CareerQuests, TeenPods, KudosSystem, 
  UserProfiles, StartupCommunities, MotivationCorner, MentorMoments } from "./index";
import Network from "./Network";

const MobileDashboard = () => {
  const [activeTab, setActiveTab] = useState("feed");

  return (
    <div className="container mx-auto px-4 py-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid grid-cols-3 mb-6">
          <TabsTrigger value="feed">Feed</TabsTrigger>
          <TabsTrigger value="goals">Goals</TabsTrigger>
          <TabsTrigger value="community">Community</TabsTrigger>
        </TabsList>

        <TabsContent value="feed" className="space-y-6">
          <Network />
          <KudosSystem />
          <MotivationCorner />
        </TabsContent>

        <TabsContent value="goals" className="space-y-6">
          <PassionTracker />
          <RoadmapBuilder />
          <CareerQuests />
        </TabsContent>

        <TabsContent value="community" className="space-y-6">
          <UserProfiles />
          <TeenPods />
          <StartupCommunities />
          <MentorMoments />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default MobileDashboard;
